import { takeLatest, call, put } from 'redux-saga/effects';
import { getMasterDataSuccess, getMasterDataFailure, getPatientProfileSuccess, getPatientProfileFailure, deletePatientProfileSuccess, deletePatientProfileFailure, getPatientDataSuccess, getPatientDataFailure, createPatientAccountSuccess, createPatientAccountFailure } from './slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../../api/client';
function* getMasterDataRequest() {
    try {
const response = yield call(apiGet, 'api/get-patient-profile-masterData');
        yield put(getMasterDataSuccess(response));
    } catch (error) {
        yield put(getMasterDataFailure(error?.response?.message || error));
    }
}

function* getPatientProfileRequest(action) {
    try {
        const { currentBranch, limit, skip, search, searchType } = action.payload;
        const qs = new URLSearchParams({
            limit: limit ?? '',
            skip: skip ?? '',
            search: search ?? '',
            searchType: searchType ?? '',
        }).toString();
        const response = yield call(apiGet, `api/get-patient-profile/${currentBranch}?${qs}`);
        yield put(getPatientProfileSuccess(response));
    } catch (error) {
        yield put(getPatientProfileFailure(error?.body?.message || error?.message));
    }
}

function* getPatientDataRequest(action) {
    try {
        const response = yield call(apiGet, `api/get-patient-data/${action.payload.type}/${action.payload.id}`);
        yield put(getPatientDataSuccess(response));
    } catch (error) {
        yield put(getPatientDataFailure(error?.body?.message || error?.message));
    }
}

function* deletePatientProfileRequest(action) {
    try {
        const response = yield call(apiDelete, `api/delete-patient-Profile/${action.payload}`);
        yield put(deletePatientProfileSuccess(response));
    } catch (error) {
        yield put(deletePatientProfileFailure(error?.response?.message || error));
    }
}

function* createPatientAccountRequest(action) {
    try {
const response = yield call(apiPost, 'api/create-patient-account', { patientId: action.payload });
        yield put(createPatientAccountSuccess(response));
    } catch (error) {
        yield put(createPatientAccountFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('patientProfile/getMasterDataRequest', getMasterDataRequest);
    yield takeLatest('patientProfile/getPatientProfileRequest', getPatientProfileRequest);
    yield takeLatest('patientProfile/getPatientDataRequest', getPatientDataRequest);
    yield takeLatest('patientProfile/deletePatientProfileRequest', deletePatientProfileRequest);
    yield takeLatest('patientProfile/createPatientAccountRequest', createPatientAccountRequest);
}

export default saga;